module.exports = __webpack_public_path__ + "static/media/arrow_udown_green.07139ae6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow_udown_green.svg
// module id = 319
// module chunks = 0